module.exports = __webpack_public_path__ + "img/spiral.191b2f65.png";